import { ProductCategory } from "@utils/constants";

const productLevelOneColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-06";
    case ProductCategory.GEMSTONE:
      return "gem-06";
    case ProductCategory.JEWELRY:
      return "jewelry-06";
    default:
      return "lab-06";
  }
};

const getProductColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-01";
    case ProductCategory.GEMSTONE:
      return "gem-01";
    case ProductCategory.JEWELRY:
      return "jewelry-01";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-01";
    case ProductCategory.LABGROWN_JEWELRY:
      return "lab-01";
    default:
      return "diam-01";
  }
};

const getProductTintColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-05";
    case ProductCategory.GEMSTONE:
      return "gem-05";
    case ProductCategory.JEWELRY:
      return "jewelry-05";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-05";
    case ProductCategory.LABGROWN_JEWELRY:
      return "lab-05";
    default:
      return "diam-05";
  }
};

const getProductBackGroundColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-03";
    case ProductCategory.GEMSTONE:
      return "gem-03";
    case ProductCategory.JEWELRY:
      return "jewelry-03";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-03";
    case ProductCategory.LABGROWN_JEWELRY:
      return "lab-03";
    default:
      return "diam-03";
  }
};

export {
  productLevelOneColor,
  getProductColor,
  getProductTintColor,
  getProductBackGroundColor,
};
